/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Clone_FromInputs */

const cs_pipelines_clone_from = /** @type {(inputs: Pipelines_Clone_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klonovat fáze z`)
};

const en_pipelines_clone_from = /** @type {(inputs: Pipelines_Clone_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clone stages from`)
};

/**
* | output |
* | --- |
* | "Clone stages from" |
*
* @param {Pipelines_Clone_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_clone_from = /** @type {((inputs?: Pipelines_Clone_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Clone_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_clone_from(inputs)
	return cs_pipelines_clone_from(inputs)
});